import ReducerRegistry from '../redux/ReducerRegistry';
import _ from 'lodash';
import { APP_WILL_MOUNT, APP_WILL_UNMOUNT, DETAIL_ROOM } from './actionTypes';
//@ts-ignore
import { SET_TIMER_COUNT_DOWN_INTERVAL, CLEAR_TIMER_COUNT_DOWN_INTERVAL, RESET_TIMER_TO_TEN_MINUTES, SET_COUNT_DOWN_TIME, SET_PROGRESS, SET_PROGRESS_TEXT, SET_CURRENT_TIME, LONG_PRESS_BUTTON
//@ts-ignore
 } from '../../base/video-pause-count-down/actionTypes';
//@ts-ignore
import { ONE_SECOND, TOTAL_TIME_COUNT } from '../../base/video-pause-count-down/const';
//@ts-ignore
import { SET_SIDEBAR_VISIBLE, SET_WELCOME_PAGE_LISTS_DEFAULT_PAGE, SET_API_TIMEOUT_MODAL, SET_FIRST_TIME_CONNECT_NETWORK, SET_UNIQUE_ID
//@ts-ignore
 } from '../../../features/welcome/actionTypes';
const STORE_CALLING = 'features/calling';
const STORE_NAME_WIFI = 'features/wifi';
const STORE_NAME_STRENGTH_NETWORK = 'features/strength-network';
const STORE_STATE_OF_WIFI = 'features/state-of-wifi';
const STORE_NAME_H = 'features/register-hatzolah';
const STORE_NAME_LANG = 'features/language';
const STORE_QUITE_MODE = 'features/quite-mode';
const STORE_OFF_MODE = 'features/off-mode';
/**
 * The name of the redux store/state property which is the root of the redux
 * state of the feature {@code welcome}.
 */
const STORE_NAME = 'features/welcome';
const STORE_NAME_UNIQUE_ID = 'features/unique-id';
const STORE_NAME_TIME_OUT = 'features/timeout-connection';
import { REMIND_WIFI, STRENGTH_NETWORK, UN_REMIND_WIFI, TOGGLE_STATE_OF_WIFI } from './actionTypes';
ReducerRegistry.register('features/base/app', (state = {}, action) => {
    switch (action.type) {
        case APP_WILL_MOUNT: {
            const { app } = action;
            if (state.app !== app) {
                return Object.assign(Object.assign({}, state), { app });
            }
            break;
        }
        case APP_WILL_UNMOUNT:
            if (state.app === action.app) {
                return Object.assign(Object.assign({}, state), { app: undefined });
            }
            break;
    }
    return state;
});
const initState = {
    detail: {
        appVersion: '',
        batteryLevel: '',
        batteryState: '',
        caseNumber: '',
        cellular: '',
        coordinates: {},
        deviceId: '',
        displayName: '',
        ipAddress: '',
        macaddr: '',
        microphoneStatus: '',
        network: '',
        offModeStatus: false,
        partType: '',
        password: '',
        pauseStatus: false,
        quietMode: false,
        roomName: '',
        speakerVolumeLevel: 0,
        ssid: '',
        strength: 0,
        timeLeft: 0,
        turnOffBy: '',
        uniqueId: '',
        videoStatus: ''
    }
};
const _getInitialState = () => {
    return {
        totalTimeCount: TOTAL_TIME_COUNT,
        timeoutMS: ONE_SECOND,
        countDownTime: TOTAL_TIME_COUNT,
        currentTime: TOTAL_TIME_COUNT,
        progressText: '07:00',
        progress: 0,
        isRedCircle: false,
        timerCountDownIntervalId: null,
        longPressButton: false
    };
};
ReducerRegistry.register('features/video-pause', (state = _getInitialState(), action) => {
    switch (action.type) {
        case SET_TIMER_COUNT_DOWN_INTERVAL: {
            return Object.assign(Object.assign({}, state), { timerCountDownIntervalId: action.timerCountDownIntervalId });
        }
        case CLEAR_TIMER_COUNT_DOWN_INTERVAL: {
            return Object.assign(Object.assign({}, state), { timerCountDownIntervalId: null });
        }
        case RESET_TIMER_TO_TEN_MINUTES: {
            return Object.assign(Object.assign({}, state), { totalTimeCount: action.totalTimeCount, countDownTime: action.countDownTime });
        }
        case SET_COUNT_DOWN_TIME: {
            return Object.assign(Object.assign({}, state), { countDownTime: action.countDownTime });
        }
        case SET_PROGRESS: {
            return Object.assign(Object.assign({}, state), { progress: action.progress });
        }
        case SET_PROGRESS_TEXT: {
            return Object.assign(Object.assign({}, state), { progressText: action.progressText });
        }
        case SET_CURRENT_TIME: {
            return Object.assign(Object.assign({}, state), { currentTime: action.currentTime });
        }
        case LONG_PRESS_BUTTON: {
            return Object.assign(Object.assign({}, state), { longPressButton: action.status });
        }
    }
    return state;
});
ReducerRegistry.register('features/detail-room', (state = initState, action) => {
    switch (action.type) {
        case DETAIL_ROOM:
            return Object.assign(Object.assign({}, state), { detail: Object.assign(Object.assign({}, state.detail), action.payload) });
    }
    return state;
});
ReducerRegistry.register(STORE_NAME_H, (state = {
    account: null
}, action) => {
    switch (action.type) {
        case 'REGISTER_ACCOUNT': {
            return Object.assign(Object.assign({}, state), { account: action.account });
        }
    }
    return state;
});
ReducerRegistry.register(STORE_NAME_LANG, (state = {
    language: {
        label: 'English',
        key: 'ENG',
        value: 'en'
    }
}, action) => {
    switch (action.type) {
        case 'CHANGE_LANGUAGE': {
            return Object.assign(Object.assign({}, state), { language: action.newLanguage });
        }
    }
    return state;
});
ReducerRegistry.register(STORE_QUITE_MODE, (state = {
    blurScreen: false,
    quiteModeActive: false,
    showAlertQuietMode: false,
    showAlertPrivacyMode: false
}, action) => {
    switch (action.type) {
        case 'BLUR_SCREEN':
            return Object.assign(Object.assign({}, state), { blurScreen: action.status });
        case 'QUITE_MODE_ACTIVE':
            return Object.assign(Object.assign({}, state), { quiteModeActive: action.status });
        case 'SHOW_ALERT_QUIET_MODE':
            return Object.assign(Object.assign({}, state), { showAlertQuietMode: action.status });
        case 'SHOW_ALERT_PRIVACY_MODE':
            return Object.assign(Object.assign({}, state), { showAlertPrivacyMode: action.status });
    }
    return state;
});
ReducerRegistry.register(STORE_OFF_MODE, (state = {
    offModeStatus: false,
    whoSelectOffMode: '',
    loadingOpenOffMode: false
}, action) => {
    switch (action.type) {
        case 'OFF_MODE_STATUS':
            return Object.assign(Object.assign({}, state), { offModeStatus: action.status });
        case 'WHO_SELECT_OFF_MODE': {
            return Object.assign(Object.assign({}, state), { whoSelectOffMode: action.val });
        }
        case 'LOADING_OPEN_OFF_MODE': {
            return Object.assign(Object.assign({}, state), { loadingOpenOffMode: action.status });
        }
    }
    return state;
});
/**
 * Reduces redux actions for the purposes of the feature {@code welcome}.
 */
ReducerRegistry.register(STORE_NAME, (state = {
    defaultPage: true,
    firstTimeConnectNetwork: false,
    uniqueId: null
}, action) => {
    switch (action.type) {
        case SET_SIDEBAR_VISIBLE:
            return Object.assign(Object.assign({}, state), { sideBarVisible: action.visible });
        case SET_WELCOME_PAGE_LISTS_DEFAULT_PAGE:
            return Object.assign(Object.assign({}, state), { defaultPage: action.status });
        case SET_FIRST_TIME_CONNECT_NETWORK:
            return Object.assign(Object.assign({}, state), { firstTimeConnectNetwork: action.status });
    }
    return state;
});
ReducerRegistry.register(STORE_NAME_TIME_OUT, (state = {
    isTimeOut: false,
    showModalMaintain: false
}, action) => {
    switch (action.type) {
        case SET_API_TIMEOUT_MODAL:
            return Object.assign(Object.assign({}, state), { isTimeOut: action.isTimeOut });
        case 'SHOW_MODAL_MAINTAIN':
            return Object.assign(Object.assign({}, state), { showModalMaintain: action.status });
    }
    return state;
});
ReducerRegistry.register(STORE_NAME_UNIQUE_ID, (state = {
    uniqueId: null
}, action) => {
    switch (action.type) {
        case SET_UNIQUE_ID:
            return Object.assign(Object.assign({}, state), { uniqueId: action.uniqueId });
    }
    return state;
});
ReducerRegistry.register(STORE_CALLING, (state = {
    hasCallFamily: false,
    hasCallPatient: false
}, action) => {
    switch (action.type) {
        case 'SET_CALL_FAMILY': {
            return Object.assign(Object.assign({}, state), { hasCallFamily: action.status });
        }
        case 'SET_CALL_PATIENT': {
            return Object.assign(Object.assign({}, state), { hasCallPatient: action.status });
        }
    }
    return state;
});
// eslint-disable-next-line require-jsdoc
function checkDuplicate(existed) {
    return _.uniq(existed);
}
ReducerRegistry.register(STORE_NAME_WIFI, (state = {
    remindedWifi: []
}, action) => {
    switch (action.type) {
        case REMIND_WIFI: {
            return Object.assign(Object.assign({}, state), { 
                //@ts-ignore
                remindedWifi: checkDuplicate(state.remindedWifi.concat(action.wifi)) });
        }
        case UN_REMIND_WIFI: {
            //@ts-ignore
            const afterFilter = state.remindedWifi.filter(item => item !== action.wifi);
            return Object.assign(Object.assign({}, state), { remindedWifi: afterFilter });
        }
    }
    return state;
});
ReducerRegistry.register(STORE_NAME_STRENGTH_NETWORK, (state = {
    strength: null
}, action) => {
    switch (action.type) {
        case STRENGTH_NETWORK: {
            return Object.assign(Object.assign({}, state), { strength: action.strength });
        }
    }
    return state;
});
ReducerRegistry.register(STORE_STATE_OF_WIFI, (state = {
    stateOfWifi: true
}, action) => {
    switch (action.type) {
        case TOGGLE_STATE_OF_WIFI: {
            return Object.assign(Object.assign({}, state), { stateOfWifi: action.stateOfWifi });
        }
    }
    return state;
});
